import { render, staticRenderFns } from "./errorToast.vue?vue&type=template&id=58f21f1a&scoped=true"
import script from "./errorToast.vue?vue&type=script&lang=js"
export * from "./errorToast.vue?vue&type=script&lang=js"
import style0 from "./errorToast.vue?vue&type=style&index=0&id=58f21f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f21f1a",
  null
  
)

export default component.exports